import React, {useEffect, useState, Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import {connect} from "react-redux";
import {NavItem, NavText} from "@trendmicro/react-sidenav";
import OrdersBase from "../../admin/components/shop/orders/OrdersBase";
import UserPrefs from "../../admin/components/dashboard/UserPrefs";
import InvoicesBase from "../../admin/components/shop/invoices/InvoicesBase";

const resourcesPanelStyle={
    "marginRight": "43px",
    "marginLeft": "13px"
}

const itemResourceTitleStyle= {

}


const ResourcesPanel = (props) => {

    const [asData, setAsData] = useState()
    const [section, setSection] = useState('dashboard')
    //show dashboard =  default

    useEffect(()=>{
        props.showCenterSection('center_zone')
    }, [])

    const handleCenterZone = (ev)=>{

        setSection(ev)
        props.setCurrentCenterPAge(ev)
        props.showCenterSection('center_zone')

    }

    return (
        <div className={'card'} style={resourcesPanelStyle}>
            <div className="card-body text-left" style={{"overflow": "hidden"}}>
                <div className="list-group list-group-flush">
                    <a hre={'#'} className="list-group-item list-group-item-action" onClick={(e)=>handleCenterZone('dashboard')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="dashboard")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="fas fa-tachometer-alt"></i> Tableau de bord </h5>
                    </a>
                    <a href={'#'} className="list-group-item list-group-item-action" onClick={(e)=>handleCenterZone('profil')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="profil")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="fas fa-user-circle "></i> Profil </h5>
                    </a>
                    <a href={'#'} className="list-group-item list-group-item-action" onClick={()=>setSection('prefs')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="prefs")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="bi bi-sliders"></i> Préférences </h5>
                        {
                            (section=='prefs')? <UserPrefs /> :null
                        }
                    </a>
                    <a href={'#'} className="list-group-item list-group-item-action" onClick={(e)=>handleCenterZone('product')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="product")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="fa fa-box-open"></i> Produits </h5>
                    </a>
                    <a href={'#'} className="list-group-item list-group-item-action" onClick={()=>setSection('bill')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="bill")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="bi bi-receipt"></i> Factures </h5>
                        {
                            (section=='bill')?<InvoicesBase />:null
                        }
                    </a>
                    <a href={'#'} className="list-group-item list-group-item-action" onClick={()=>setSection('orders')}>
                        <h5 style={itemResourceTitleStyle} className={(section!="orders")?"p-2 rounded border border-secondary":"p-2 rounded border border-primary text-light bg-primary"}><i className="fas fa-shopping-cart"></i> Commandes</h5>
                        {
                            (section=='orders')?<OrdersBase />:null

                        }
                    </a>
                </div>
            </div>
        </div>
    )
}



const mapStateToProps = state => {
    return {

    }
}

const mapDispatchTProps = dispatch => {
    return {
        showcurrentSection: (e) => dispatch( {type: 'SHOW_CURRENT_SECTION', data:e}),
        setCurrentCenterPAge: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(ResourcesPanel);
